import { z } from 'zod';

const envSchema = z.object({
  VITE_SUPABASE_URL: z.string().url(),
  VITE_SUPABASE_ANON_KEY: z.string().min(1),
  VITE_APP_ENV: z.enum(['development', 'staging', 'production']).default('development'),
  VITE_APP_NAME: z.string().default('AMV Gomecano Back Office'),
  VITE_HEURE_HMV: z.string().default('52.17'),
});

export const env = envSchema.parse(import.meta.env);
